import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useContent } from '../lib/ContentContext';
import { PageHero } from '../components/site/PageHero';
import { SectionHeading } from '../components/site/SectionHeading';
import { ProductTable } from '../components/site/ProductTable';

export default function TextileCategory() {
  const { slug } = useParams();
  const { content } = useContent();
  const textilePage = content?.textile_page;
  const category = content?.textile_products?.categories?.[slug];

  if (!content) return null;
  if (!category) {
    return (
      <div className="py-24 text-center">
        <h1 className="text-2xl font-extrabold text-[#26247B]">Category not found</h1>
        <Link to="/textile-chemicals" className="mt-4 inline-flex text-[#2E8B57] font-bold hover:underline">
          Back to Textile Chemicals
        </Link>
      </div>
    );
  }

  return (
    <div>
      <PageHero title={category.title} subtitle="Textile Chemicals Product Range" image={textilePage?.hero_image} />
      <section className="py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <Link to="/textile-chemicals" className="inline-flex items-center gap-2 text-[#2E8B57] font-bold text-sm mb-8 hover:underline">
            <ArrowLeft className="h-4 w-4" /> Back to Textile Product Categories
          </Link>
          <SectionHeading className="mb-6">{category.title}</SectionHeading>
          {category.intro && (
            <div className="mb-10 w-full space-y-4" data-testid="textile-category-intro">
              {(Array.isArray(category.intro) ? category.intro : [category.intro]).map((p, i) => (
                <p
                  key={i}
                  className="cms-html w-full text-justify text-black/80 leading-8"
                  dangerouslySetInnerHTML={{ __html: p }}
                />
              ))}
            </div>
          )}
          <ProductTable columns={category.columns} rows={category.rows} />
        </div>
      </section>
    </div>
  );
}
